import api from '@/api';
import {
  BenefitConsumable,
  BenefitConsumableListRequest,
  BenefitConsumableListResponse,
} from './benefits-consumable.types';

const API = '/operational/v1/benefit-consumables';

export default {
  async list(params: BenefitConsumableListRequest) {
    const result = (await api.get(API, params)) as unknown;
    return result as BenefitConsumableListResponse;
  },

  async detail(consumableId: number) {
    const result = (await api.get(`${API}/${consumableId}`, null)) as unknown;
    return result as BenefitConsumable;
  },
};
